import styled from 'styled-components';

export const Container = styled.div`
  padding: 1.2rem;
  display: flex;
  flex-wrap: wrap;
  gap: 1.4rem;
`;
